import { BaseService } from "mrb/core";
import { ArtistUploadApiRouteService } from "common/services";

class ArtistUploadService extends BaseService {
    constructor(apiClient) {
        super(apiClient, new ArtistUploadApiRouteService());
    }

    createUploadSession(producerId, data, abortSignal = null) {
        const url = this.routeService.createUploadSession(producerId);
        return this.apiClient.post(url, data, null, abortSignal);
    }

    completeUploadSession(producerId, sessionId, abortSignal = null) {
        const url = this.routeService.completeUploadSession(producerId, sessionId);
        return this.apiClient.post(url, null, null, abortSignal);
    }

    getLatestUploadSession(producerId, abortSignal = null) {
        const url = this.routeService.getLatestUploadSession(producerId);
        return this.apiClient.get(url, null, abortSignal);
    }
}

export default ArtistUploadService;
